import React from 'react';
import './Login.css';
import apiService from '../services/api';


const login_url = window._env_?.REACT_APP_LOGIN_URL;
//const login_url = process.env.REACT_APP_LOGIN_URL;


const CRSurveyLogo= apiService.getBlobAssetUrl('CSAT_Logo.svg');
const CriticalRiverLogo= apiService.getBlobAssetUrl('CR_white_Logo.svg');
const loginBackground = apiService.getBlobAssetUrl('background.svg');

const LoginPage = () => {
  const handleLogin = (e) => {
    e.preventDefault();
    window.location.href = login_url;
  };

  return (
    <div className="login-7" style={{ '--login-bg': `url(${loginBackground})` }}>
      <div className="login-container" id="login-6">
        <div className="text-center mb-3">
          <img src={CRSurveyLogo} alt="CRSurvey Logo" className="logo-img" id="login-3" />
        </div>
        <div>
          <p className="login-heading" id="login-2">LOGIN</p>
          <p className="login-subtext" id="login-1">
            Seamless Access to Limitless Insights. Start Your Journey Effortlessly.
          </p>
          <form method="POST" id="loginForm" onSubmit={handleLogin}>
            <button type="submit" className="btn btn-dark btn-block loginbuttonClr" id="login-4">
              LOG IN WITH CRITICALRIVER<img src={CriticalRiverLogo} className="login-icon" alt="CR Logo" id="login-5" />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;